import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    ChangeDetectorRef,
    Input
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    ActivityDaysServiceProxy,
    AllocatedPersonnelDto,
    AllocatePersonnelForActivityDayInput,
    UpdateAllocatedPersonnelListForActivityDayInput,
} from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'app-assign-personal-table',
    templateUrl: './assign-personnel-table.component.html',
    styleUrls: ['./assign-personnel-table.component.less']
})
export class AssignPersonnelTableModelComponent extends AppComponentBase {

    @Input() componentMode: 'allocationSheet' | 'default' = 'default';
    @Input() controlDisabled: boolean;
    @Input() allowedPersonnel: any;
    @Input() allocatedPersonnel: any;
    @Input() activityDayId: string;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    @Input() anyResourceSelected: boolean;

    @ViewChild('personnelSelectorTable') personnelSelectorTable: ModalDirective;

    saving: boolean = false;

    @Output()
    onAssignedCounterUpdate: EventEmitter<number> = new EventEmitter<number>();

    public filteredPersonnel: Array<any> = [];
    public currentAllocatedPersonnel: any;
    constructor(
        injector: Injector,
        private _activityDaysServiceProxy: ActivityDaysServiceProxy,
        private cdr: ChangeDetectorRef
    ) {
        super(injector);
    }

    keyPress(event){
        return event.value.length>2?null:event.value;
    }
    ngAfterViewInit() {
        this.setInitialPersonnelSelectorValue();
    }

    isAllocationSheet() {
        return this.componentMode === 'allocationSheet';
    }
    selectPerson(person, selected) {
        let selectedPerson = this.filteredPersonnel.find((p) => p.staffDetails.personnelId == person.staffDetails.personnelId);
        selectedPerson.selected = selected;
        if(selected){
            const params = new AllocatePersonnelForActivityDayInput({
                activityDayId: this.activityDayId,
                personnel: new AllocatedPersonnelDto({
                    actualHours: 0,
                    personnelId: person.staffDetails.personnelId,
                }),
            });

            this._activityDaysServiceProxy.allocatePersonnel(params).subscribe(() => {
                this._activityDaysServiceProxy
                    .getMyActivityDayForEdit(this.activityDayId)
                    .subscribe((data) => {
                        this.currentAllocatedPersonnel.allocatedPersonnel.push({
                            personnelDetails: person.staffDetails.contactDetails,
                            actualHours: 0,
                            personnelId: person.staffDetails.personnelId
                        });
                        this.updateTotals();
                        abp.event.trigger('app.evt.activityChanged');
                    });
            });
        }else{
            this._activityDaysServiceProxy
            .removeAllocatedPersonnel(this.activityDayId, person.staffDetails.personnelId)
            .subscribe(() => {
                this.currentAllocatedPersonnel.allocatedPersonnel = this.currentAllocatedPersonnel.allocatedPersonnel?.filter(c => c.personnelId != person.staffDetails.personnelId);
                this.updateTotals();
            });
        }
        this.cdr.detectChanges();
    }
    show(): void {
        this.personnelSelectorTable.show();
    }

    showError(): boolean {
        const selectedPersonal = this.getSelectedPersonal();
        const total = selectedPersonal && selectedPersonal.length >0 ?selectedPersonal.map(x=>x.actualHours).reduce((a, b) => { return a + b }):0;
        return total<=0
    }

    save(): void {
        this.saving = true;
    }

    close(): void {
        this.personnelSelectorTable.hide();
    }
    getSelectedPersonal() {
        return this.currentAllocatedPersonnel && this.currentAllocatedPersonnel.allocatedPersonnel ? this.currentAllocatedPersonnel.allocatedPersonnel : [];
    }
    setInitialPersonnelSelectorValue() {
        this.filteredPersonnel = this.allowedPersonnel.map((p) => {
            let selected = this.allocatedPersonnel.allocatedPersonnel.some((c) => c.personnelId == p.staffDetails.personnelId) || false;
            return { ...p, selected,  filterShow: true};
        });
        this.currentAllocatedPersonnel = { ...this.allocatedPersonnel };
        this.updateTotals();
        this.cdr.detectChanges();
    }
    filteredPersonnelList(recent){
        if(recent){
            let filtered = this.filteredPersonnel?.filter(p => p.wasRecentlyAssigned && p.filterShow );
            return filtered;
        }
        let filtered = this.filteredPersonnel?.filter(p => p.filterShow);
        return filtered;
    }

    updateAllocatedPersonnelList(event) {
        if(event.target.value){
			if(event.target.value < 1 || event.target.value > 24) {
                this.notify.error('Hours value only allowed between 1 to 24');
                return;
            }
            const params = new UpdateAllocatedPersonnelListForActivityDayInput({
                activityDayId: this.activityDayId,
                personnelList: [...this.currentAllocatedPersonnel.allocatedPersonnel].map((item) => {
                    return new AllocatedPersonnelDto({
                        actualHours: item.actualHours,
                        personnelId: item.personnelId,
                    });
                }),
            });

            this._activityDaysServiceProxy
                .updateAllocatedPersonnelList(params)
                .subscribe(() => {
                    this.updateTotals();
                    abp.event.trigger('app.evt.activityChanged');
                });
        }

    }

    updateTotals() {
        let personnelSum = 0;
        this.currentAllocatedPersonnel.allocatedPersonnel.forEach(
            (item) => (personnelSum += parseInt(item.actualHours))
        );
        this.onAssignedCounterUpdate.emit(personnelSum);
    }

    removeItem(personnelId: string) {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._activityDaysServiceProxy
                    .removeAllocatedPersonnel(this.activityDayId, personnelId)
                    .subscribe(() => {
                        this.currentAllocatedPersonnel.allocatedPersonnel = this.currentAllocatedPersonnel.allocatedPersonnel?.filter(
                            (personnel) => personnel.personnelId != personnelId
                        );
                        var personalDetail = this.filteredPersonnel.find(c=> c.staffDetails.personnelId == personnelId);
                        personalDetail.selected = false;
                        this.updateTotals();
                        abp.event.trigger('app.evt.activityChanged');
                    });

                this.cdr.detectChanges();
            }
        });
    }

    getPersonnelDeleteToolTip(personnel: any): string
    {
        return this.l('DeletePersonnel') + ' ' +
        personnel.personnelDetails.firstName + ' ' +
        personnel.personnelDetails.lastName;
    }

    ClearRecent(): void {

        this._activityDaysServiceProxy.clearAllocatedPersonnelRecent()
        .subscribe(() => {
            this.filteredPersonnel.forEach(personnel => {
                personnel.wasRecentlyAssigned = false;
            });
        });
    }

    filtersChange(filters) {
        this.filteredPersonnel.forEach(f=>{
            let hide = false;
            if(filters.filterText && !(
                f.staffDetails.contactDetails.firstName.toLowerCase().includes(filters.filterText.toLowerCase()) ||
                f.staffDetails.contactDetails.lastName.toLowerCase().includes(filters.filterText.toLowerCase()) ||
                (f.staffDetails.contactDetails.firstName.toLowerCase() + ' ' + f.staffDetails.contactDetails.lastName.toLowerCase()).includes(filters.filterText.toLowerCase()) ||
                f.staffDetails.contactDetails.emailAddress.toLowerCase().includes(filters.filterText.toLowerCase()) )){
                    hide = true;
            }
            if(!hide && (filters.location && filters.location.locationName && !(filters.location.locationName == f.location))){
                hide = true;
            }
            if(!hide && (filters.company && filters.company.company && !(filters.company.company == f.company))){
                hide = true;
            }
            if(!hide && (filters.trade && filters.trade.trade && !(filters.trade.trade == f.trade))){
                hide = true;
            }

            f.filterShow = !hide;
        });
        this.cdr.detectChanges();
    }

    checkFilteredPersonnelNull(data) {
        let sr = '';
        data.forEach(person=>{
            if(!person.wasRecentlyAssigned && person.filterShow) {
                sr = 'record_found';
            }
        })
        if(sr == 'record_found') {
            return false;
        } else {
            return true;
        }
    }
}
